module.exports = __webpack_public_path__ + "media/images/emblems/Lax-95fcab485717d074453ae6bcf5b4a486.png";